<template>
    <MainContentSearchable
        :title="'Listado de emails ' + getTitle(listado_emails)"
        v-model="filters"
        :meta="loading ? {} : listado.meta"
        @updated="getListadoEmails"
    >
        <template v-slot:content v-if="!loading">
            <div
                v-if="listado.data.length > 0"
                class="table-responsive has-options"
            >
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th>Email</th>
                            <th v-if="listado_emails === 'abiertos'">
                                Nº de aperturas
                            </th>
                            <th v-if="listado_emails === 'clickados'">
                                Nº de clicks
                            </th>
                            <th v-if="listado_emails === 'devueltos'">
                                Severidad
                            </th>
                        </tr>
                    </thead>
                    <tbody v-if="!loading">
                        <template v-for="(email, index) in listado.data">
                            <tr :key="index">
                                <td>{{ email.email }}</td>
                                <td v-if="listado_emails === 'abiertos'">
                                    {{ email.n_aperturas }}
                                </td>
                                <td v-if="listado_emails === 'clickados'">
                                    {{ email.n_clicks }}
                                </td>
                                <td v-if="listado_emails === 'devueltos'">
                                    {{
                                        email.severity === "temporary"
                                            ? "Temporal"
                                            : "Permanente"
                                    }}
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
            <div v-else>
                <span class="font-weight-bold">
                    No hay emails que coincidan con tu búsqueda
                </span>
            </div>
        </template>
    </MainContentSearchable>
</template>

<script>
    import MainContentSearchable from "@/components/backend/components/MainContentSearchable";

    export default {
        props: ["evento_id", "listado_emails"],
        components: {
            MainContentSearchable
        },
        data() {
            return {
                listado: {},
                filters: {
                    per_page: 10,
                    page: 1,
                    search: "",
                },
                loading: true,
                expand: [],
            };
        },
        created() {
            this.getListadoEmails();
        },
        methods: {
            getListadoEmails() {
                const data = {
                    filters: {
                    ...this.filters,
                    listado: this.listado_emails,
                    },
                    evento_id: this.evento_id,
                };

                this.$store.dispatch(this.config.getVuexAlias('back.events.informe.emails.listado'), data)
                    .then(res => {
                        this.listado = res.data;
                    })
                    .finally(() => (this.loading = false));
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal, borrado) {
                this.$modal.hide(modal);
                if (borrado) {
                    this.getListadoEmails();
                }
            },
            getTitle(listado_emails) {
                return listado_emails === "spam"
                    ? "marcados como spam"
                    : listado_emails;
            },
        },
    };
</script>
